module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    attrs: {
      "id": "portfolio"
    }
  }, [_h('p', ["\n    This is a list in alphabetical order of some recent and/or notable projects.\n    Most of them I developed single-handedly; for the rest I was principal developer.\n  "]), " ", _vm._l((_vm.portfoliolist), function(item) {
    return _h('portfolio-item', {
      attrs: {
        "id": item.id,
        "title": item.title,
        "desc": item.desc,
        "url": item.url || item.id
      }
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1831884e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio.vue
// module id = 49
// module chunks = 1